import React from "react";
import "./heading.css";

export const Heading = () => {
  return (
    <>
      <div className="heading-upper">
        <div className="name">
          <div className="BHAKTI-SASHTRI">BHAKTI SASHTRI</div>
        </div>
      </div>

      <div className="flex-col text-center">
        <div className="BhaktiSastri-section-heading">
          <h1 className="BhaktiSastri-heading">
            Bhakti Sastri Course – Study Bhagavad Gita & Vedic Texts
          </h1>
          <h2 className="BhaktiSastri-subheading">
            Deepen Your Bhakti Through Scriptural Wisdom
          </h2>
        </div>
        <h1 className="items-center md:text-[48px] text-[20px] mt-3 text-red font-semibold md:block hidden">
          Bhakti Shastri Program at ISKCON Vijayawada:
        </h1>
        <h1 className="items-center md:text-[48px] text-[20px] mt-3 text-red font-semibold block md:hidden">
          Program at ISKCON Vijayawada:
        </h1>
        <h1 className="md:text-[48px] text-[20px] text-red font-bold">
          Deepening Scriptural Knowledge
        </h1>
      </div>
    </>
  );
};
